'use client';

import type {FC} from 'react';

import {useQuery} from '@/sanity/loader/useQuery';

import {Navbar} from '../../components/Navbar';
import {SITE_SETTINGS_QUERY, type SiteSettingsQueryResult} from '../query';

import {navigationTypeFromSiteSettingsFragment} from './query';

type Props = {
	initial: SiteSettingsQueryResult;
};

export const NavbarDraft: FC<Props> = ({initial}) => {
	const {data: siteSettings} = useQuery<SiteSettingsQueryResult>(initial, SITE_SETTINGS_QUERY);

	if (!siteSettings) {
		return null;
	}

	return <Navbar navigation={navigationTypeFromSiteSettingsFragment(siteSettings)} />;
};

export default NavbarDraft;
